﻿'use strict';

angular.module('ntmApp')
  .directive('formatConversion', ['$compile', '$sce', function ($compile, $sce) {
      return {
          restrict: 'EA',
          scope: {
              stringToConvert: '=',
              fieldsAndValuesObject: '='
          },
          link: function (scope, element) {

              scope.ConversionTypes = {
                  DurationSplitHM: 'displayAsDurationSplitHM',
                  DurationSplit: 'displayAsDurationSplit',
                  DurationHoursShort: 'displayAsDurationHoursShort',
                  Icon: 'displayAsIcon',
                  ColorSquareWithLetter: 'displayAsColorSquareWithLetter',
                  ColorSquare: 'displayAsColorSquare',
                  Boolean: 'displayAsBoolean',
                  DefaultString: 'displayAsDefaultString',

                  getConversionType: function (conversionString) {
                      for (var convType in this) {
                          if (this.hasOwnProperty(convType) && this[convType] === conversionString) {
                              return this[convType];
                          }

                          return this.DefaultString;
                      }
                  },

                  getBooleanConversion: function (booleanValue) {
                      if (booleanValue === true) {
                          return 'Yes';
                      }
                      if (booleanValue === false) {
                          return 'No';
                      }

                      return 'No';
                  }
              };

              function getStringDisplayHTML(parsedCountDisplayString) {
                  var str = '';
                  var i = 0;
                  var strHTML = '';

                  var countDisplayColumnPropList = [];

                  while (i < parsedCountDisplayString.length) {
                      if (parsedCountDisplayString[i] === '{') {
                          for (var j = i + 1; j < parsedCountDisplayString.length; j++) {
                              if (parsedCountDisplayString[j] === '}') {
                                  var valueSubstring = '';
                                  str = parsedCountDisplayString.substring(i, j + 1);

                                  if (str.indexOf('|') !== -1) {
                                      countDisplayColumnPropList.push({
                                          value: '',
                                          displayAs: (str.substring(str.indexOf('|') + 1, str.length - 1)),
                                          preValueString: countDisplayColumnPropList.length === 0 ? $sce.trustAsHtml(parsedCountDisplayString.substring(0, (parsedCountDisplayString.indexOf('{') !== -1) ? parsedCountDisplayString.indexOf('{') : parsedCountDisplayString.length)) : '',
                                          postValueString: $sce.trustAsHtml(parsedCountDisplayString.substring(j + 1, (parsedCountDisplayString.indexOf('{', j + 1) !== -1) ? parsedCountDisplayString.indexOf('{', j + 1) : parsedCountDisplayString.length))
                                      });

                                      valueSubstring = str.substring(1, str.indexOf('|'));

                                      if ((str.substring(str.indexOf('|') + 1, str.length - 1)) === scope.ConversionTypes.DurationSplitHM) {
                                          countDisplayColumnPropList[countDisplayColumnPropList.length - 1].value = convertToStringNumber(valueSubstring);

                                          if (valueSubstring === 'null') {
                                              countDisplayColumnPropList[countDisplayColumnPropList.length - 1].value = '';
                                          }

                                          strHTML += countDisplayColumnPropList[countDisplayColumnPropList.length - 1].preValueString +
                                                     '<span class="inline-block" format-minutes input-minutes-value="countDisplayColumnPropList[' + (countDisplayColumnPropList.length - 1) + '].value" format-type="\'shortFormat\'"></span>' +
                                                     countDisplayColumnPropList[countDisplayColumnPropList.length - 1].postValueString;
                                      }
                                      if ((str.substring(str.indexOf('|') + 1, str.length - 1)) === scope.ConversionTypes.DurationSplit) {
                                          countDisplayColumnPropList[countDisplayColumnPropList.length - 1].value = convertToStringNumber(valueSubstring);

                                          if (valueSubstring === 'null') {
                                              countDisplayColumnPropList[countDisplayColumnPropList.length - 1].value = '';
                                          }

                                          strHTML += countDisplayColumnPropList[countDisplayColumnPropList.length - 1].preValueString +
                                                     '<span class="inline-block" format-minutes input-minutes-value="countDisplayColumnPropList[' + (countDisplayColumnPropList.length - 1) + '].value" format-type="\'longFormat\'"></span>' +
                                                     countDisplayColumnPropList[countDisplayColumnPropList.length - 1].postValueString;
                                      }
                                      if ((str.substring(str.indexOf('|') + 1, str.length - 1)) === scope.ConversionTypes.DurationHoursShort) {
                                          countDisplayColumnPropList[countDisplayColumnPropList.length - 1].value = convertToStringNumber(valueSubstring || 0);

                                          if (valueSubstring === 'null') {
                                              countDisplayColumnPropList[countDisplayColumnPropList.length - 1].value = '';
                                          }

                                          strHTML += countDisplayColumnPropList[countDisplayColumnPropList.length - 1].preValueString +
                                                     '<span class="inline-block" format-minutes input-minutes-value="countDisplayColumnPropList[' + (countDisplayColumnPropList.length - 1) + '].value"></span>' +
                                                     countDisplayColumnPropList[countDisplayColumnPropList.length - 1].postValueString;
                                      }
                                      if ((str.substring(str.indexOf('|') + 1, str.length - 1)) === scope.ConversionTypes.Icon) {
                                          countDisplayColumnPropList[countDisplayColumnPropList.length - 1].value = JSON.stringify({ type: 'awesome', image: valueSubstring });

                                          if (valueSubstring === 'null') {
                                              countDisplayColumnPropList[countDisplayColumnPropList.length - 1].value = '';
                                          }

                                          strHTML += countDisplayColumnPropList[countDisplayColumnPropList.length - 1].preValueString +
                                                     '<icon-display icon="countDisplayColumnPropList[' + (countDisplayColumnPropList.length - 1) + '].value"></icon-display>' +
                                                     countDisplayColumnPropList[countDisplayColumnPropList.length - 1].postValueString;
                                      }
                                      if ((str.substring(str.indexOf('|') + 1, str.length - 1)) === scope.ConversionTypes.ColorSquare) {
                                          countDisplayColumnPropList[countDisplayColumnPropList.length - 1].value = JSON.stringify({ type: 'awesome', image: valueSubstring });

                                          if (valueSubstring === 'null') {
                                              countDisplayColumnPropList[countDisplayColumnPropList.length - 1].value = '';
                                          }

                                          strHTML += countDisplayColumnPropList[countDisplayColumnPropList.length - 1].preValueString +
                                                     '<span style="background-color:{{ countDisplayColumnPropList[' + (countDisplayColumnPropList.length - 1) + '].value }}">&nbsp;</span>' +
                                                     countDisplayColumnPropList[countDisplayColumnPropList.length - 1].postValueString;
                                      }
                                      if ((str.substring(str.indexOf('|') + 1, str.length - 1)) === scope.ConversionTypes.Boolean) {
                                          countDisplayColumnPropList[countDisplayColumnPropList.length - 1].value = valueSubstring;

                                          if (valueSubstring === 'null') {
                                              countDisplayColumnPropList[countDisplayColumnPropList.length - 1].value = '';
                                          }

                                          strHTML += countDisplayColumnPropList[countDisplayColumnPropList.length - 1].preValueString +
                                                     scope.ConversionTypes.getBooleanConversion(countDisplayColumnPropList[countDisplayColumnPropList.length - 1].value) +
                                                     countDisplayColumnPropList[countDisplayColumnPropList.length - 1].postValueString;
                                      }
                                  } else {
                                      valueSubstring = str.substring(1, str.length - 1);

                                      countDisplayColumnPropList.push({
                                          value: valueSubstring,
                                          preValueString: countDisplayColumnPropList.length === 0 ? $sce.trustAsHtml(parsedCountDisplayString.substring(0, (parsedCountDisplayString.indexOf('{') !== -1) ? parsedCountDisplayString.indexOf('{') : parsedCountDisplayString.length)) : '',
                                          postValueString: $sce.trustAsHtml(parsedCountDisplayString.substring(j + 1, (parsedCountDisplayString.indexOf('{', j + 1) !== -1) ? parsedCountDisplayString.indexOf('{', j + 1) : parsedCountDisplayString.length))
                                      });

                                      if (valueSubstring === 'null') {
                                          countDisplayColumnPropList[countDisplayColumnPropList.length - 1].value = '';
                                      }

                                      strHTML += countDisplayColumnPropList[countDisplayColumnPropList.length - 1].preValueString +
                                                 countDisplayColumnPropList[countDisplayColumnPropList.length - 1].value +
                                                 countDisplayColumnPropList[countDisplayColumnPropList.length - 1].postValueString;
                                  }

                                  break;
                              }
                          }
                      }

                      i++;
                  }

                  scope.countDisplayColumnPropList = countDisplayColumnPropList;

                  strHTML = '<div class="inline-block formatted-output-container">' + strHTML + '</div>';
                  var compiledHTML = $compile(strHTML)(scope);
                  element.append(compiledHTML);
              }

              function convertToStringNumber(stringValue) {
                  if (stringValue === "null" || stringValue === "NaN") {
                      return "0";
                  }

                  return stringValue || "0";
              }

              function getStringDisplay(countDisplayColumn, fieldsAndValuesObject) {

                  var str = '';
                  var i = 0;

                  var countDisplayColumnCopy = countDisplayColumn;

                  while (i < countDisplayColumn.length) {
                      if (countDisplayColumn[i] === '{') {
                          for (var j = i + 1; j < countDisplayColumn.length; j++) {
                              if (countDisplayColumn[j] === '}') {
                                  str = countDisplayColumn.substring(i, j + 1);
                                  if (str.indexOf('|') !== -1) {
                                      str = str.substring(1, str.indexOf('|'));
                                  } else {
                                      str = str.substring(1, str.length - 1);
                                  }

                                  break;
                              }
                          }

                          countDisplayColumnCopy = countDisplayColumnCopy.replaceAll(str, fieldsAndValuesObject[str]);
                      }

                      i++;
                  }

                  getStringDisplayHTML(countDisplayColumnCopy);
              }

              var init = function () {
                  scope.conversionType = scope.ConversionTypes.Icon;

                  if (scope.fieldsAndValuesObject) {
                      getStringDisplay(scope.stringToConvert, scope.fieldsAndValuesObject);
                  } else {
                      getStringDisplayHTML(scope.stringToConvert);
                  }
              };

              init();
          }
      };
  }]);